const translations = {
    createOrganization: 'Create An Organization',
    selectOrganization: 'Select an existing organization or create a new organization',
    title: 'Welcome!'
};

export default translations;
